"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
/*
Flips over a face, reverses normal
 */
exports.flip = (face) => ({
    vertices: face.vertices.slice().reverse(),
    normal: face.normal.clone().multiplyScalar(-1),
    colour: face.colour
});
/*
Centre of some vertices
 */
exports.centre = (vertices) => {
    let x = 0, y = 0, z = 0;
    vertices.forEach(v => {
        x += v.x;
        y += v.y;
        z += v.z;
    });
    if (vertices.length === 0)
        throw new Error("trying to get average of 0 Vector3s!");
    return new THREE.Vector3(x / vertices.length, y / vertices.length, z / vertices.length);
};
/*
Scale a face (about its centre, preserves normal)
 */
exports.scale = (face, scale) => {
    if (scale <= 0)
        throw new Error("Scale must be positive");
    const c = exports.centre(face.vertices);
    const vertices = face.vertices.map(v => c.clone().add(v
        .clone()
        .sub(c)
        .multiplyScalar(scale)));
    return {
        vertices,
        normal: face.normal,
        colour: face.colour
    };
};
exports.cloneFace = (face) => ({
    vertices: face.vertices.map(v => v.clone()),
    normal: face.normal.clone(),
    colour: face.colour
});
exports.translateFace = (face, by, colour) => ({
    vertices: face.vertices.map(v => v.clone().add(by)),
    normal: face.normal,
    colour
});
exports.faceSize = (face) => face.vertices[0].distanceTo(face.vertices[1]);
exports.rotate = (face, about, aroundAxis, angle) => {
    const vertices = face.vertices.map(origV => {
        const v = origV.clone().sub(about);
        const c1 = v.clone().multiplyScalar(Math.cos(angle));
        const c2 = v
            .clone()
            .cross(aroundAxis)
            .multiplyScalar(Math.sin(angle));
        const c3 = aroundAxis
            .clone()
            .multiplyScalar(aroundAxis.dot(v) * (1 - Math.cos(angle)));
        return c1
            .add(c2)
            .add(c3)
            .add(about);
    });
    return {
        normal: face.normal.clone(),
        colour: face.colour,
        vertices
    };
};



// WEBPACK FOOTER //
// ./src/components/three/face.ts